<footer class="container-fluid footer">
  <div class="row rsp-container">
    <div id="footer-org" class="col-md-4 col-xs-12 px-0">
      @if (isAtLeastOneTranslationAvailable(['rspFooterOrgLabel', 'rspFooterOrgNumber', 'rspFooterOrgNumber2'])) {
        <dl>
          @if (shouldSingleElementBeDisplayed('rspFooterOrgLabel')) {
            <dt [innerHTML]="'rspFooterOrgLabel' | translate"></dt>
          }
          @if (isAtLeastOneTranslationAvailable(['rspFooterOrgNumber', 'rspFooterOrgNumber2'])) {
            <dd>
              <p>
                @if (shouldSingleElementBeDisplayed('rspFooterOrgNumber')) {
                  <span [innerHTML]="'rspFooterOrgNumber' | translate"></span><br />
                }
                @if (shouldSingleElementBeDisplayed('rspFooterOrgNumber2')) {
                  <span [innerHTML]="'rspFooterOrgNumber2' | translate"></span>
                }
              </p>
            </dd>
          }
        </dl>
      }
    </div>
    <div id="footer-address" class="col-md-4 col-xs-12 px-0">
      @if (
        isAtLeastOneTranslationAvailable([
          'rspFooterAddressLabel',
          'rspFooterAddress1',
          'rspFooterAddress2',
          'rspFooterAddress3',
          'rspFooterAddress4',
        ])
      ) {
        <dl>
          @if (shouldSingleElementBeDisplayed('rspFooterAddressLabel')) {
            <dt [innerHTML]="'rspFooterAddressLabel' | translate"></dt>
          }
          @if (isAtLeastOneTranslationAvailable(['rspFooterAddress1', 'rspFooterAddress2', 'rspFooterAddress3', 'rspFooterAddress4'])) {
            <dd>
              <p>
                @if (shouldSingleElementBeDisplayed('rspFooterAddress1')) {
                  <span [innerHTML]="'rspFooterAddress1' | translate"></span><br />
                }
                @if (shouldSingleElementBeDisplayed('rspFooterAddress2')) {
                  <span [innerHTML]="'rspFooterAddress2' | translate"></span><br />
                }
                @if (shouldSingleElementBeDisplayed('rspFooterAddress3')) {
                  <span [innerHTML]="'rspFooterAddress3' | translate"></span><br />
                }
                @if (shouldSingleElementBeDisplayed('rspFooterAddress4')) {
                  <span [innerHTML]="'rspFooterAddress4' | translate"></span>
                }
              </p>
            </dd>
          }
        </dl>
      }
    </div>
    <div id="footer-phone-email" class="col-md-4 col-xs-12 px-0">
      @if (
        isAtLeastOneTranslationAvailable([
          'rspFooterPhoneLabel',
          'rspFooterPhone',
          'rspFooterEmailLabel',
          'rspFooterEmail',
          'rspFooterAdditionalContactLabel',
          'rspFooterAdditionalContact',
        ])
      ) {
        <dl class="grid">
          @if (isAtLeastOneTranslationAvailable(['rspFooterPhoneLabel', 'rspFooterPhone'])) {
            <dt [innerHTML]="'rspFooterPhoneLabel' | translate"></dt>
            <dd [innerHTML]="'rspFooterPhone' | translate"></dd>
          }
          @if (isAtLeastOneTranslationAvailable(['rspFooterEmailLabel', 'rspFooterEmail'])) {
            <dt [innerHTML]="'rspFooterEmailLabel' | translate"></dt>
            <dd [innerHTML]="'rspFooterEmail' | translate"></dd>
          }
          @if (isAtLeastOneTranslationAvailable(['rspFooterAdditionalContactLabel', 'rspFooterAdditionalContact'])) {
            <dt [innerHTML]="'rspFooterAdditionalContactLabel' | translate"></dt>
            <dd [innerHTML]="'rspFooterAdditionalContact' | translate"></dd>
          }
        </dl>
      }
    </div>
  </div>
</footer>
